export const handleExternalLinkClick = (link = '') => {
  window.location = link;
};

export const parseRoutePath = (link, params = {}) => link.replace(
  // eslint-disable-next-line no-useless-escape
  /:([^\/]+)/g,
  (_, item) => params[item] || `:${item}`,
);
